import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class Picture extends Vue {
  @Prop({ default: () => {} })
    value: MiniPagePicture;

  @Prop({ default: false })
    disabled: boolean;

  data: MiniPagePicture = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  uploadSuccess(res) {
    this.data.desc.pictureUrl = res.content;
  }

  render(h) {
    return (
      <div class="r-mx-20 r-my-10">
        <div class="picture">
          <p class="blockTitle center-text-title ">上传图片</p>
          <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.data.desc.pictureUrl} disabled={this.disabled} maxSize={2048} />
          <p class="tip">注：图片宽度建议为750px，大小不超过2M，支持jpg、png、gif格式图片。</p>
        </div>
      </div>
    );
  }
}
